import { Path } from 'config/portal'
import { AgreementsMapping } from 'config/products'
import { RecordTypes } from 'flatfile-config'
import { IRA_AMOUNT } from '../../../config/iraAmount'
import { convertNumber } from 'utils'
import { PlanConfirmationForm } from '../forms'
import { selectors } from '../reducer'
import * as actions from '../actions'
import * as apiActions from 'api-actions'
import createPlanConfirmationView, {
  createGetActiveBenefitAboveThresholdParticipants,
} from '../../products/views/createPlanConfirmationView'

const getRolloverAmount = (participant) =>
  convertNumber(participant[IRA_AMOUNT.TRADITIONAL_PRE_TAX]) +
  convertNumber(participant[IRA_AMOUNT.TRADITIONAL_AFTER_TAX]) +
  convertNumber(participant[IRA_AMOUNT.ROTH])

export default createPlanConfirmationView({
  PlanConfirmationFormComponent: PlanConfirmationForm,
  agreementsMapping: AgreementsMapping.ARO_PLAN_MATCHING,
  nextPath: '/automatic-rollovers/review-and-submit-participant-data',
  uploadFilePath: '/automatic-rollovers/upload-file',
  allParticipantsRemovedPath: Path.SERVICES_AGREEMENTS,
  recordType: RecordTypes.ARO_PARTICIPANT,
  getActiveBenefitAboveThresholdParticipants:
    createGetActiveBenefitAboveThresholdParticipants(getRolloverAmount),
  selectors,
  actions,
  fetchAgreementsAction: apiActions.fetchCompletedServicesAgreements,
  agreementsSelectorFn: (state) => selectors.completedServicesAgreements(state),
})
